import React from "react";

interface HookFormSwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
  containerClassName?: string;
}

/**
 * Toggle als natives checkbox-`<input>` — funktioniert direkt mit react-hook-form
 * (`{...register("field")}`) inkl. `ref`-Forwarding.
 *
 * Außerhalb von react-hook-form den controlled {@link Switch} (`checked`/`onChange`)
 * bevorzugen. Diesen nur nutzen, wenn die input/register-Integration gebraucht wird.
 * Optik identisch zu {@link Switch}: hellgrauer Off-Track + weißer Knob, dark-mode-fest.
 */
const switchClass =
  "relative float-left mt-0.5 h-5 w-10 cursor-pointer appearance-none rounded-10 border border-solid border-line-strong bg-zinc-300 align-top transition-all duration-250 ease-soft-in-out dark:bg-zinc-600 after:absolute after:top-px after:h-4 after:w-4 after:translate-x-px after:rounded-circle after:bg-[#fff] after:shadow-soft-2xl after:duration-250 after:content-[''] checked:border-primary checked:bg-primary checked:after:translate-x-5.3 disabled:cursor-not-allowed disabled:opacity-60";

export const HookFormSwitch = React.forwardRef<HTMLInputElement, HookFormSwitchProps>(function HookFormSwitch(
  { label, containerClassName = "", className = "", id, ...props },
  ref
) {
  return (
    <div className={containerClassName}>
      {label != null && label !== "" && (
        <label htmlFor={id} className="mb-1 block text-sm font-medium text-content-2">
          {label}
        </label>
      )}
      <input ref={ref} id={id} type="checkbox" className={`${switchClass} ${className}`} {...props} />
    </div>
  );
});
